module.exports = __webpack_public_path__ + "static/media/patient.17912d51.png";